import { render, staticRenderFns } from "./KnowledgeDirectorySelect.vue?vue&type=template&id=39863598&scoped=true"
import script from "./KnowledgeDirectorySelect.vue?vue&type=script&lang=js"
export * from "./KnowledgeDirectorySelect.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeDirectorySelect.vue?vue&type=style&index=0&id=39863598&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39863598",
  null
  
)

export default component.exports